import script from "./SectionTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTemplate.vue?vue&type=script&setup=true&lang=js"

import "./SectionTemplate.vue?vue&type=style&index=0&id=2754a5cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2754a5cc"]])

export default __exports__